import React, { useState, useContext, useEffect } from "react"
import PropTypes from "prop-types"
import { makeStyles } from "@material-ui/core/styles"
import { CircularProgress, Link, Modal } from "@mui/material"
import ProjectContext from "context/projects/projectContext"
import i18n from "i18n"
import ModalExcel from "pages/Dashboard/ModalExcel"
import ExcelDropzone from "components/Dropzone/ExcelDropzone"
import { HelveticaBold } from "common/typographies"
import { DownloadingOutlined } from "@mui/icons-material"
import { useHistory } from "react-router-dom/cjs/react-router-dom"

function getModalStyle() {
  const top = 50
  const left = 50
  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  }
}

const useStyles = makeStyles(theme => ({
  paper: {
    position: "absolute",
    width: "550px",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    borderRadius: 6,
    maxHeight: "calc(100vh - 100px)",
    overflowY: "auto",
    overflowX: "hidden",
  },
}))
const UploadExcelModal = ({
  openModal,
  setOpenModal,
  proyecto,
  setWaitModal,
  i18nTitle,
  isTCQ,
}) => {
  const history = useHistory()
  const [selectedFiles, setSelectedFiles] = useState([])
  const projectContext = useContext(ProjectContext)
  const [modalStyle] = useState(getModalStyle)
  const classes = useStyles()
  const [notExcel, setNotExcel] = useState(false)
  const { UploadProject, UploadProjectFromTCQ } = projectContext
  const [open, setOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const onUpload = async () => {
    setIsLoading(true)
    for (let i = 0; i < selectedFiles.length; i++) {
      let extension = selectedFiles[i].path.substr(
        selectedFiles[i].path.length - 3,
      )
      let extension2 = selectedFiles[i].path.substr(
        selectedFiles[i].path.length - 4,
      )
      if (
        extension == "xls" ||
        extension2 == "xlsx" ||
        extension == "XLS" ||
        extension2 == "XLSX"
      ) {
        if (isTCQ) {
          await UploadProjectFromTCQ({
            file: selectedFiles[i],
            infoProject: proyecto,
          })
          history.push(`/budgeting/${proyecto.projectId}`)
        } else {
          await UploadProject({ file: selectedFiles[i], infoProject: proyecto })
        }
      }
    }
    setWaitModal(true)
    setOpenModal(false)
  }

  useEffect(() => {
    if (notExcel == true) {
      setOpen(true)
    }
  }, [notExcel])

  return (
    <>
      <Modal
        open={openModal}
        onClose={() => {
          null
        }}
      >
        <>
          <div style={modalStyle} className={classes.paper}>
            <div className={"py-4"}>
              <p
                className="text-center my-3"
                style={{
                  fontStyle: "normal",
                  fontWeight: "500",
                  fontSize: "22px",
                  lineHeight: "23px",
                  color: "#414141",
                }}
              >
                {i18n.t("¡Importante!")}
              </p>
              <HelveticaBold
                className="text-center my-3"
                style={{
                  fontWeight: "700",
                  lineHeight: "10px",
                  fontSize: "14px",
                  cursor: "pointer",
                  color: "#414141",
                }}
              >
                {isTCQ
                  ? i18n.t(i18nTitle)
                  : i18n.t("project.excel.downloadTemplate")}
              </HelveticaBold>
              <HelveticaBold
                className="text-center my-3"
                style={{
                  fontWeight: "500",
                  lineHeight: "23px",
                  fontSize: "14px",
                  cursor: "pointer",
                  color: "#414141",
                }}
              >
                {!isTCQ && i18n.t("project.excel.conversionNote")}
              </HelveticaBold>
              <div
                className="inline"
                style={{
                  marginLeft: "50px",
                  marginRight: "50px",
                  justifyContent: "center",
                  marginTop: "-10px",
                }}
              >
                {isTCQ ? (
                  <Link
                    href="https://help.planhopper.com/en/help/articles/5624641-como-importar-archivos-tcq-en-planhopper"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {i18n.t("project.tcq.seeInstructions")}
                  </Link>
                ) : (
                  <a href="https://cdn.tribboo.co/Plantilla%20Presupuesto%20PlanHopper.xlsx">
                    <div className="inline" style={{ cursor: "pointer" }}>
                      <DownloadingOutlined
                        style={{ marginTop: "5px", color: "#4461D7" }}
                      />
                      <HelveticaBold
                        style={{
                          marginLeft: "10px",
                          fontSize: "12px",
                          fontWeight: "500",
                          paddingTop: "7px",
                          color: "#4461D7",
                          textDecoration: "underline",
                          textDecorationLine: "#4461D7",
                        }}
                      >
                        Modelo Proyecto - Presupuesto Simple.xlsx
                      </HelveticaBold>
                    </div>
                  </a>
                )}
              </div>
              <button
                type="button"
                onClick={() => {
                  setOpenModal(false)
                }}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{ padding: "0 5rem" }}>
              <ExcelDropzone
                selectedFiles={selectedFiles}
                setselectedFiles={setSelectedFiles}
                setNotExcel={setNotExcel}
                i18nTitle={isTCQ ? "project.tcq.dropzoneText" : undefined}
                i18nDescription={isTCQ ? "project.tcq.validFormats" : undefined}
              />
            </div>

            <div id="centerButton">
              {selectedFiles.length == 0 || isLoading ? (
                <button
                  type="button"
                  className="AddProjectDisabled"
                  style={{
                    marginTop: "-10px",
                    marginBottom: "30px",
                    ...(isLoading && {
                      display: "flex",
                      justifyContent: "space-around",
                      alignItems: "center",
                    }),
                  }}
                >
                  {i18n.t("Subir")}
                  {isLoading && (
                    <CircularProgress size={20} style={{ color: "black" }} />
                  )}
                </button>
              ) : (
                <button
                  data-amplify-analytics-on="click"
                  data-amplify-analytics-name="ExcelUploaded"
                  data-amplify-analytics-attrs={selectedFiles}
                  type="button"
                  className="AddContact"
                  onClick={onUpload}
                  style={{ marginTop: "-10px", marginBottom: "30px" }}
                >
                  {i18n.t("Subir")}
                </button>
              )}
            </div>
          </div>
        </>
      </Modal>
      <ModalExcel open={open} setOpen={setOpen} setNotExcel={setNotExcel} />
    </>
  )
}

UploadExcelModal.propTypes = {
  openModal: PropTypes.bool.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  proyecto: PropTypes.object,
  setWaitModal: PropTypes.func.isRequired,
  i18nTitle: PropTypes.string,
  isTCQ: PropTypes.bool,
}

export default UploadExcelModal
